import React from "react";

import { LocationMusicStatsContainer } from "../../location/musicStatistics/LocationMusicStatsContainer";
const LocationMusicStatisticsRoute = (props) => {
    const crematoryIdRaw = props?.match?.params?.crematoryID;
    const locationId = crematoryIdRaw ? parseInt(crematoryIdRaw, 10) : 0;

    return (
        <div className="container">
            <LocationMusicStatsContainer locationId={locationId} />
        </div>
    );
};

export default LocationMusicStatisticsRoute;
